<script setup>
import { toRefs } from 'vue';
import { useAuthenticator } from '@aws-amplify/ui-vue';
// `route` `user` and `signOut` all are reactive.
const { route, user } = toRefs(useAuthenticator());
</script>
<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar" :class="$route.meta.sidebarClass">
    <div class="slimScrollDiv">
      <div class="sidebar-inner slimscroll">
        <perfect-scrollbar
          class="scroll-area"
          :settings="settings"
          @ps-scroll-y="scrollHanle"
        >
          <div id="sidebar-menu" class="sidebar-menu">
            <ul>
              <li class="submenu-open">
                <h6 class="submenu-hdr">Main</h6>
                <ul>
                  <li v-bind:class="{
                    active: currentPath == 'index' || currentPath == 'index',
                  }" title="Press Shift + D">
                    <router-link to="index"><vue-feather type="grid"></vue-feather><span> Dashboard <span class="shortcut-text">Shift + D</span></span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="submenu-open">
                <h6 class="submenu-hdr">Products</h6>
                <ul>
                  <li title="Press Shift + I">
                    <router-link :class="currentPath == 'productlist' || currentPath == 'editproduct'
                      ? 'active'
                      : 'notactive'
                      " to="productlist"><vue-feather type="box"></vue-feather><span>Items <span class="shortcut-text">Shift + I</span></span></router-link>
                  </li>
                  <li title="Press Shift + C">
                    <router-link :class="currentPath == 'categorylist' ? 'active' : 'notactive'"
                      to="categorylist"><vue-feather type="codepen"></vue-feather><span>Category <span class="shortcut-text">Shift + C</span></span></router-link>
                  </li>
                </ul>
              </li>
              <li class="submenu-open">
                <h6 class="submenu-hdr">Issue</h6>
                <ul>
                  <li title="Press Shift + O">
                    <router-link :class="currentPath == 'saleslist' || currentPath == 'sales-details'
                      ? 'active'
                      : 'notactive'
                      " to="saleslist"><vue-feather type="shopping-cart"></vue-feather><span>Issue <span class="shortcut-text">Shift + O</span></span></router-link>
                  </li>
                </ul>
              </li>
              <li class="submenu-open">
                <h6 class="submenu-hdr">Purchases</h6>
                <ul>
                  <li title="Press Shift + P">
                    <router-link :class="currentPath == 'purchaselist' || currentPath == 'editpurchase'
                      ? 'active'
                      : 'notactive'
                      " to="purchaselist"><vue-feather
                        type="shopping-bag"></vue-feather><span>Purchases <span class="shortcut-text">Shift + P</span></span></router-link>
                  </li>
                </ul>
              </li>

              <li class="submenu-open">
                <h6 class="submenu-hdr">Peoples</h6>
                <ul>
                  <li title="Press Shift + N">
                    <router-link :class="currentPath == 'customerlist' ? 'active' : 'notactive'"
                      to="customerlist"><vue-feather type="user"></vue-feather><span>Branches <span class="shortcut-text">Shift + N</span></span></router-link>
                  </li>
                  <li title="Press Shift + E">
                    <router-link :class="currentPath == 'dealerlist' || currentPath == 'adddealer' || currentPath == 'editdealer' ? 'active' : 'notactive'"
                      to="dealerlist"><vue-feather type="briefcase"></vue-feather><span>Dealers <span class="shortcut-text">Shift + E</span></span></router-link>
                  </li>
                  <li title="Press Shift + S">
                    <router-link :class="currentPath == 'supplierlist' ? 'active' : 'notactive'"
                      to="supplierlist"><vue-feather type="users"></vue-feather><span>Suppliers <span class="shortcut-text">Shift + S</span></span></router-link>
                  </li>
                </ul>
              </li>
              <li class="submenu-open">
                <h6 class="submenu-hdr">Reports</h6>
                <ul>
                  <li title="Press Shift + G">
                    <router-link :class="currentPath == 'generalreport' ? 'active' : 'notactive'"
                      to="generalreport"><vue-feather type="bar-chart-2"></vue-feather><span>General
                        Report <span class="shortcut-text">Shift + G</span></span></router-link>
                  </li>
                  <!-- <li>
                    <router-link
                      :class="currentPath == 'inventoryreport' ? 'active' : 'notactive'"
                      to="inventoryreport"
                      ><vue-feather type="credit-card"></vue-feather
                      ><span>Inventory Report</span></router-link
                    >
                  </li> -->
                  <li title="Press Shift + R">
                    <router-link :class="currentPath == 'purchasereport' ? 'active' : 'notactive'"
                      to="purchasereport"><vue-feather type="bar-chart"></vue-feather><span>Summary
                        Report <span class="shortcut-text">Shift + R</span></span></router-link>
                  </li>
                  <!-- <li>
                    <router-link
                      :class="currentPath == 'supplierreport' ? 'active' : 'notactive'"
                      to="supplierreport"
                      ><vue-feather type="database"></vue-feather
                      ><span>Supplier Report</span></router-link
                    >
                  </li> -->
                </ul>
              </li>


            </ul>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
  <!-- /Sidebar -->
</template>
<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
export default {
  data() {
    return {
      productMenu: false,
      salesMenu: false,
      purchaseMenu: false,
      expenseMenu: false,
      quotationMenu: false,
      transferMenu: false,
      returnMenu: false,
      peopleMenu: false,
      placesMenu: false,
      errorpageMenu: false,
      reportMenu: false,
      userMenu: false,
      settingMenu: false,
      elementMenu: false,
      chartMenu: false,
      iconMenu: false,
      formMenu: false,
      tableMenu: false,
      chatMenu: false,
      authenticationPageMenu: false,
      settings: {
        suppressScrollX: true,
      },
      activeClass: "active",
      currentPath: this.$route.name,
    };
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (event.shiftKey) {
        switch (event.key.toLowerCase()) {
          case 'd':
            this.$router.push({ name: 'index' }); // Dashboard
            break;
          case 'p':
            this.$router.push({ name: 'purchaselist' }); // Purchases
            break;
          case 'i':
            this.$router.push({ name: 'productlist' }); // Items
            break;
          case 'c':
            this.$router.push({ name: 'categorylist' }); // Category
            break;
          case 'o':
            this.$router.push({ name: 'saleslist' }); // Issue
            break;
          case 'g':
            this.$router.push({ name: 'generalreport' }); // General Report
            break;
          case 'r':
            this.$router.push({ name: 'purchasereport' }); // Summary Report
            break;
          case 'n':
            this.$router.push({ name: 'customerlist' }); // Branches
            break;
          case 'e':
            this.$router.push({ name: 'dealerlist' }); // Dealers
            break;
          case 's':
            this.$router.push({ name: 'supplierlist' }); // Suppliers
            break;
          default:
            break;
        }
      }
    },
    scrollHanle(evt) { },
    isCustomDropdown() {
      //Search bar
      var searchOptions = document.getElementById("search-close-options");
      var dropdown = document.getElementById("search-dropdown");
      var searchInput = document.getElementById("search-options");

      searchInput.addEventListener("focus", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchInput.addEventListener("keyup", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchOptions.addEventListener("click", () => {
        searchInput.value = "";
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.getAttribute("id") !== "search-options") {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#sidebar")) {
          let a = document
            .querySelector("#sidebar")
            .querySelector('[href="' + ele + '"]');

          if (a) {
            a.classList.add("active");
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add("active");
              parentCollapseDiv.parentElement.children[0].setAttribute(
                "aria-expanded",
                "true"
              );
              if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement
                  .closest(".collapse")
                  .classList.add("show");
                if (
                  parentCollapseDiv.parentElement.closest(".collapse")
                    .previousElementSibling
                )
                  parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      }, 1000);
    },
  },
  components: {
    PerfectScrollbar,
  },
  watch: {
    $route(to) {
      this.currentPath = to.name;
    }
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
    productMenu() {
      return (
        this.$route.name == "productlist" ||
        this.$route.name == "product-details" ||
        this.$route.name == "addproduct" ||
        this.$route.name == "editproduct" ||
        this.$route.name == "editcategory" ||
        this.$route.name == "categorylist" ||
        this.$route.name == "addcategory"
      );
    },
    salesMenu() {
      return (
        this.$route.name == "saleslist" ||
        this.$route.name == "sales-details" ||
        this.$route.name == "pos" ||
        this.$route.name == "add-sales" ||
        this.$route.name == "editsalesreturns" ||
        this.$route.name == "edit-sales" ||
        this.$route.name == "salesreturnlists" ||
        this.$route.name == "createsalesreturns"
      );
    },
    purchaseMenu() {
      return (
        this.$route.name == "purchaselist" ||
        this.$route.name == "addpurchase" ||
        this.$route.name == "editpurchase"
      );
    },
    expenseMenu() {
      return (
        this.$route.name == "expenselist" ||
        this.$route.name == "createexpense" ||
        this.$route.name == "editexpense" ||
        this.$route.name == "expensecategory"
      );
    },
    peopleMenu() {
      return (
        this.$route.name == "customerlist" ||
        this.$route.name == "addcustomer" ||
        this.$route.name == "editcustomer" ||
        this.$route.name == "dealerlist" ||
        this.$route.name == "adddealer" ||
        this.$route.name == "editdealer" ||
        this.$route.name == "supplierlist" ||
        this.$route.name == "editsupplier" ||
        this.$route.name == "addsupplier"
      );
    },
    reportMenu() {
      return (
        this.$route.name == "inventoryreport" ||
        this.$route.name == "generalreport" ||
        this.$route.name == "salesreport" ||
        this.$route.name == "purchasereport" ||
        this.$route.name == "supplierreport" ||
        this.$route.name == "customerreport"
      );
    },
    userMenu() {
      return (
        this.$route.name == "newuser" ||
        this.$route.name == "userlists" ||
        this.$route.name == "newuseredit"
      );
    },
    settingMenu() {
      return (
        this.$route.name == "editpermission" ||
        this.$route.name == "createpermission" ||
        this.$route.name == "currencysettings" ||
        this.$route.name == "grouppermissions" ||
        this.$route.name == "taxrates"
      );
    },
    tableMenu() {
      return this.$route.name == "tables-basic" || this.$route.name == "data-tables";
    },
    currentPath() {
      return this.$route.name;
    },
  },
};
</script>
<style scoped>
.shortcut-text {
  display: block;
  font-size: 8px; 
  margin-left: 1px;
  color: rgb(161, 161, 161); 
}
</style>
